import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {
  constructor() {}

  public exportAsExcelFile(json: any[], excelFileName: string, headerList = null): void {
    let worksheet: XLSX.WorkSheet;
    if (headerList) {
      worksheet = XLSX.utils.json_to_sheet(json, { header: headerList });
    } else {
      worksheet = XLSX.utils.json_to_sheet(json);
    }
    //console.log('worksheet', worksheet);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Audit info': worksheet },
      SheetNames: ['Audit info'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
    // FileSaver.saveAs(data, fileName + '_' + EXCEL_EXTENSION);
  }
}
